////////////////////////////////////////////////////////////////
// Finite State Machine: Handles playcanvas application state
////////////////////////////////////////////////////////////////
const FSM = {
  currentState: {},
  states: [],
  init: function () {
    FSM.instance = this;
    this.initStates();
    this.currentState = null;
  },
  update: function (dt) {
    this.currentState.ageDelta += dt;
    this.currentState.execute(dt);
  },
  initStates: function () {
    this.states = {};
    Object.keys(this.stateNames).forEach((key) => {
      this.states[key] = FSM.createState(key);
    });
  },
  createState: function (stateName) {
    const state = {
      name: stateName,
      ageDelta: 0,
      enter: function () {
      },
      execute: function (dt) { },
      exit: function () {
      },
      onTrigger: function (triggerName) {
        // console.log(this.name + ' trigger: ' + triggerName);
      },
    };
    return state;
  },
  getState: function (stateName) {
    return this.states[stateName];
  },
  setState: function (newState) {
    // console.log("set state: " + newState.name);
    if (this.currentState !== null) {
      this.currentState.exit();
    }

    if (this.currentState !== newState) {
      this.currentState = newState;
      this.currentState.ageDelta = 0;
      this.currentState.enter();
    }
  },

  trigger: function (triggerName, metadata = null) {
    this.currentState.onTrigger(triggerName, metadata);
  },

  triggers: {
    NEXT: 'NEXT',
    BACK: 'BACK',
  },
  stateNames: {
    INIT: 'INIT',
    LOAD_LANDING: 'LOAD_LANDING',
    LANDING: 'LANDING',

    LOAD_CLOCK: 'LOAD_CLOCK',
    GOTO_CLOCK: 'GOTO_CLOCK',
    CLOCK: 'CLOCK',

    LOAD_PLANT: 'LOAD_PLANT',
    PLANT: 'PLANT',
    PLANT_BREATH: 'PLANT_BREATH',
  },
};

FSM.init();
export { FSM };
